import { red } from "app/styles/variables/colors";
import { black, brightBlue900, gray300, red1100 } from "app/styles/variables/colors_tiles_v4";
import { primaryFont } from "app/styles/variables/fonts";
import React, { useState } from "react";
import styled from "styled-components";


interface Props{
    handleApplyCode: Function;
    handleRemoveClaimCode: Function;
    iconUrl?: String;
    keyName: String;
}

export const ApplyCode = (props: Props) => {

    const [allowEnterCode, setAllowEnterCode] = useState(false);
    const [isCodeApplied, setIsCodeApplied] = useState({success: false, discountMsg: ''});
    const [code, setCode] = useState('');
    const [error, setError] = useState({
        isError: false,
        errorMsg: '',
    })

    const {
        handleRemoveClaimCode = () => {},
        handleApplyCode,
        iconUrl = "https://vega.slooh.com/assets/v4/dashboard-new/blue_plus_icon.svg",
        keyName = '',
    } = props;

    const handleTextChange = (e: any) => {
        if(e.target.value?.length === 0){
            setError({
                isError: false,
                errorMsg: '',
            });
        }
        setCode(e.target.value);
    }

    const handleClearCode = () => {
        setCode('');
        setIsCodeApplied({success: false, discountMsg: ''})
        setError({
            isError: false,
            errorMsg: '',
        });
    }

    const handleRemoveCode = () => {
        handleRemoveClaimCode(keyName);
        setCode('');
        setIsCodeApplied({success: false, discountMsg: ''})
        setError({
            isError: false,
            errorMsg: '',
        });
    }

    const handleCodeSubmit = async () => {
        
        const result = await handleApplyCode(code.toUpperCase(), keyName);
        if(result.isError){
            setError(result)
        }
        else{
            setIsCodeApplied(result);
        }
    }

    return (
        <ApplyCodeContainer>
            {allowEnterCode ? (
                isCodeApplied.success && !error.isError ? (
                    <CodeAppliedContainer>
                        <CodeAppliedTextContainer>
                            <CodeAppliedText>{code}</CodeAppliedText>
                            <ApplyText onClick={handleRemoveCode}>Remove</ApplyText>
                        </CodeAppliedTextContainer>
                        <CodeDescText>{isCodeApplied.discountMsg}</CodeDescText>
                    </CodeAppliedContainer>
                ) : (
                    <Container>
                        <CodeInputContainer error={error.isError}>
                            <InputBox value={code} onChange={handleTextChange} placeHolder={"Enter Claim Code"} />
                            {code.length > 0 && ( 
                                error.isError ? (
                                    <RemoveIcon onClick={handleClearCode} src="https://vega.slooh.com/assets/v4/dashboard-new/black_circle_filled_close_icon.svg" />
                                ) : (
                                    <ApplyText onClick={handleCodeSubmit}>Apply</ApplyText>
                                )
                            )}
                        </CodeInputContainer>
                        {error.isError && (
                            <ErrorInfoContainer>
                                <ErrorIcon src="https://vega.slooh.com/assets/v4/site-redesign/icons/alert.svg" />
                                <ErrorMsg>{error.errorMsg}</ErrorMsg>
                            </ErrorInfoContainer>
                        )}  
                    </Container>
                )
            ) : (
                <ApplyButtonContainer onClick={() => setAllowEnterCode(true)}>
                    <Icon src={iconUrl} />
                    <ApplyText>Apply a claim code</ApplyText>
                </ApplyButtonContainer>
            )}
            
        </ApplyCodeContainer>
    );
}

const Container = styled.div`
    width: 100%;
`;

const ApplyCodeContainer = styled.div`
    width: 100%;
`;

const ApplyButtonContainer = styled.div`
    display: flex;
    align-items: center;
    gap: 4px;
    cursor: pointer;
`;

const Icon = styled.img`
    width: 16px;
    height: 16px;
`;

const CodeInputContainer = styled.div<{error: boolean}>`
    width: 100%;
    border-radius: 5px;
    border: 1px solid ${({error}) => error ? red : gray300};
    padding: 9px 12px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    background-color: ${({error}) => error ? red1100 : 'transparent'};

    &:focus-within {
        border: 2px solid ${({error}) => error ? red : brightBlue900};
    }
    
`;

const InputBox = styled.input`
    width: 100%;
    font-family: ${primaryFont};
    font-size: 16px;
    font-weight: 420;
    line-height: 22px;
    letter-spacing: 1px;
    color: ${black};
    text-transform: uppercase;
    border: none;
    outline: none;
    background: transparent;
`;

const ApplyText = styled.span`
    text-transform: uppercase;
    font-family: ${primaryFont};
    font-size: 12px;
    font-weight: 450;
    line-height: 12px;
    letter-spacing: 1px;
    color: ${brightBlue900};
    cursor: pointer;
`;

const RemoveIcon = styled.img`
    margin-left: 4px;
    width: 22px;
    height: 22px;
    cursor: pointer;
`;

const ErrorInfoContainer = styled.div`
    display: flex;
    gap: 4px;
    align-items: center;
    margin-top: 4px;
`;

const ErrorIcon = styled.img`
    width: 16px;
    height: 16px;
`;

const ErrorMsg = styled.span`
    font-family: ${primaryFont};
    font-size: 14px;
    font-weight: 390;
    line-height: 20px;
    color: ${red};
`;

const CodeAppliedText = styled.h5`
    font-family: ${primaryFont};
    font-size: 16px;
    font-weight: 420;
    line-height: 22px;
    letter-spacing: 1px;
    color: ${black};
    text-transform: uppercase;
`;

const CodeDescText = styled.h6`
    font-family: ${primaryFont};
    font-size: 14px;
    font-weight: 390;
    line-height: 22.4px;
`;

const CodeAppliedContainer = styled.div`
    padding: 16px;
    border: 1px solid ${gray300};
    border-radius: 5px;
`;

const CodeAppliedTextContainer = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
`;